import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SelectField } from '../../../../common/components/ReduxFormField/index';
import { Field, getFormValues, reduxForm } from 'redux-form';
import {
  Alert,
  Box,
  Button,
  HorizontalFormControl,
} from '../../../../common/components/index';
import { get } from 'lodash';
import { Col, Row, Form } from 'react-bootstrap';
import { InternalButtonBar } from '../../../layout/components/InternalButtonBar/InternalButtonBar';
import { actions } from '../../redux/sourceTypeActions';
import { bindActionCreators } from 'redux';
import { flow } from 'lodash';

const FORM_NAME = 'sourceTypeForm';

const validate = () => {};

class SourceTypeForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    array: PropTypes.object.isRequired,
    resource: PropTypes.object,
    formValues: PropTypes.object,
  };

  handleSubmit = (resource) => {
    const { actions } = this.props;
    if (resource.data.id) {
      actions.updateSourceType(resource);
    } else {
      actions.createSourceType(resource);
    }
  };

  render() {
    const { formValues, handleSubmit, submitting } = this.props;
    return (
      <Box>
        <h2 className="resource-name">{get(formValues, 'attributes.name')}</h2>
        <Form horizontal className="role-form" onSubmit={handleSubmit(this.handleSubmit)}>
          <Row>
            <Col xs={12}>
              <Alert />
            </Col>
          </Row>

          <Row>
            <Col xs={6}>
              <Field
                name="data.attributes.name"
                label="Name"
                labelSize={1}
                component={HorizontalFormControl}
              />
            </Col>
            <Col xs={6}>
              <Field
                name="data.attributes.source_type"
                label="Type"
                labelSize={1}
                component={SelectField}
                options={[
                  { label: 'Direct', value: 'Direct' },
                  { label: 'Broker', value: 'Broker' },
                  { label: 'Aggregator', value: 'Aggregator' },
                ]}
              />
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <InternalButtonBar
                buttons={[
                  {
                    permissions: ['marketing.source_create'],
                    button: (
                      <Button
                        className="pull-right"
                        type="submit"
                        bsStyle="primary"
                        label="Save Source Group"
                        isLoading={submitting}
                      />
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        </Form>
      </Box>
    );
  }
}

export default flow([
  reduxForm({
    form: FORM_NAME,
    validate,
  }),
  connect(
    (state, props) => {
      const initialValues = props.resource;
      const formValues = getFormValues(FORM_NAME)(state);
      return {
        initialValues,
        formValues,
      };
    },
    (dispatch) => ({
      actions: bindActionCreators(actions, dispatch),
      dispatch,
    }),
  ),
])(SourceTypeForm);
